/*********************** Custom JS for Boost AI Search & Discovery  ************************/

/* Starts Boost 199967 */
const moveHeaderTitle = (componentRegistry) => {
  componentRegistry.useComponentPlugin("HeaderTitle", {
    name: "Move Collection Title to The Toolbar",
    apply: () => {
      let hasUpdated = false; // Prevent rendering twice
      return {
        afterRender(element) {
          const headerTitle = element.getRootElm();
          if (headerTitle && !hasUpdated) {
            hasUpdated = true;
            const toolbarContent = document.querySelector(
              ".boost-sd__toolbar-content"
            ); // Select product list
            if (toolbarContent) {
              toolbarContent.prepend(headerTitle); // Move into toolbar
            }
          }
        },
      };
    },
  });
};

const addBreadcrumb = (componentRegistry) => {
  componentRegistry.useComponentPlugin("Breadcrumb", {
    name: "Add breadcrumb above title",
    apply: () => {
      let hasUpdated = false; // Prevent rendering twice
      return {
        afterRender(element) {
          const breadCrumb = element.getRootElm();
          if (breadCrumb && !hasUpdated) {
            hasUpdated = true;
            const boostSDRight = document.querySelector(".boost-sd-right"); // Select product list
            if (boostSDRight) {
              boostSDRight.prepend(breadCrumb); // Move to above collection title
            }
          }
        },
      };
    },
  });
};
const moveHeaderDescription = (componentRegistry) => {
  componentRegistry.useComponentPlugin("HeaderDescription", {
    name: "Move Collection Description to The Toolbar",
    apply: () => {
      let hasUpdated = false;
      return {
        afterRender(element) {
          const headerDescription = element.getRootElm();
          if (headerDescription && !hasUpdated) {
            hasUpdated = true;
            const toolbarContent = document.querySelector(
              ".boost-sd__toolbar-content"
            ); 
            if (toolbarContent) {
              toolbarContent.prepend(headerDescription);
            }
          }
        },
      };
    },
  });
};
/* Starts Boost 199967 */
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  moveHeaderDescription, 
  moveHeaderTitle,
  addBreadcrumb,
]);
// =====================collection wishlist appp =======================

if (window.boostSDAppConfig) {
window.boostSDAppConfig.integration =  Object.assign({
wishlists: 'king'
}, window.boostSDAppConfig.integration || {});
}

// =================================== 


